export const LEAGUES = {
  NBA: 'nba',
  MLB: 'mlb'
};

const ROUTES = {
  home: '/',
  about: '/about',
  category: '/category',
  epg: '/epg',
  info: '/info',
  login: '/login',
  viewAll: '/view-all',
  movieDetails: '/movie',
  myContent: '/mycontent',
  paringCode: '/pairing-code',
  profile: '/profile',
  search: '/search',
  show: '/show',
  showDetails: '/tvshow',
  player: '/player',
  schedule: '/schedule',
  calendar: '/schedule/calendar',
  mlb: '/mlb',
  mlbSchedule: '/mlb-schedule',
  mlbGameDetails: '/mlb-game-details',
  collection: '/collection',
  programDetails: '/program',
  profileSelection: '/profiles/profile-selection',
  manageProfile: '/profiles/manage-profile',
  createProfile: '/profiles/create-profile',
  changeProfileAvatar: '/profiles/change-profile-avatar',
  changeProfileName: '/profiles/change-profile-name',
  createPin: '/profiles/create-pin',
  changePin: '/profiles/change-pin',
  informPin: '/profiles/inform-pin',
  deletePin: '/profiles/delete-pin'
}; // TODO: Devs please align with your routesMapping

const PROVIDER_TYPE = {
  cms: 'cms',
  i18n: 'i18n',
  ovp: 'ovp',
  config: 'config'
};

const SHELF_CONTAINER_IDS = {
  Carousel: 'Carousel',
  Default: 'Default',
  Grid: 'Grid',
  HeroBanner: 'HeroBanner',
  ChannelBanner: 'ChannelBanner',
  CharacterCarousel: 'CharacterCarousel',
  FilterSort: 'FilterSort'
};

const {
  Carousel,
  CharacterCarousel,
  Grid,
  HeroBanner,
  ChannelBanner,
  FilterSort
} = SHELF_CONTAINER_IDS;

/* These are manually used templates */
const CUSTOM_CONTAINER_ID_TEMPLATE_MAP = {
  'carousel-link': Carousel,
  'featured-carousel-portrait': Carousel,
  'carousel-landscape': Carousel,
  'grid-portrait-loadmore': Grid,
  'grid-wide-loadmore': Grid
};

/* These are templates from Accedo One Control */
const ACCEDO_CONTROL_CONTAINER_TEMPLATES = {
  hero: 'elevate-hero-banner',
  continueWatching: 'elevate-continue-watching',
  carouselPortrait: 'elevate-carousel-portrait',
  carouselWide: 'elevate-carousel-wide',
  carouselCategoryPortrait: 'elevate-carousel-category-portrait',
  carouselCategoryWide: 'elevate-carousel-category-wide',
  gridHorizontalPortrait: 'elevate-grid-horizontal-portrait',
  gridHorizontalWide: 'elevate-grid-horizontal-wide',
  gridVerticalPortrait: 'elevate-grid-vertical-portrait',
  gridVerticalWide: 'elevate-grid-vertical-wide',
  carouselViewAllPortrait: 'elevate-carousel-view-all-portrait',
  carouselCategories: 'elevate-carousel-categories',
  filterSort: 'elevate-filter-sort', // to be deprecated
  carouselJumpRecommendation: 'elevate-jump-portrait',
  carouselWideBig: 'elevate-carousel-wide-big',
  carouselWideBigMlb: 'elevate-carousel-wide-big-mlb',
  charactersRail: 'elevate-characters',
  imageRail: 'elevate-image',
  channelsRail: 'elevate-channels'
};

const DEFAULT_TEMPLATE = ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortrait;

const ACCEDO_CONTROL_CONTAINER_ID_TEMPLATE_MAP = {
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.hero]: HeroBanner,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.continueWatching]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselPortrait]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWide]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.gridVerticalPortrait]: Grid,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.gridVerticalWide]: Grid,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselViewAllPortrait]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselCategories]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.filterSort]: FilterSort,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselJumpRecommendation]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.charactersRail]: CharacterCarousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.channelsRail]: ChannelBanner,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWideBig]: Carousel,
  [ACCEDO_CONTROL_CONTAINER_TEMPLATES.carouselWideBigMlb]: Carousel
};

const CONTAINER_ID_TEMPLATE_MAP = {
  ...ACCEDO_CONTROL_CONTAINER_ID_TEMPLATE_MAP,
  ...CUSTOM_CONTAINER_ID_TEMPLATE_MAP
};

const CONTAINER_ITEM_TYPES = {
  Movie: 'movie',
  TvShow: 'tvshow',
  Episode: 'episode',
  Category: 'category',
  Show: 'show',
  Bookmark: 'bookmark',
  Live: 'live',
  Character: 'character',
  Program: 'program'
};

const DETAIL_ROUTES = {
  [CONTAINER_ITEM_TYPES.Movie]: '/movie/:item-id:',
  [CONTAINER_ITEM_TYPES.TvShow]: '/show/:item-id:',
  [CONTAINER_ITEM_TYPES.Bookmark]: '/player',
  [CONTAINER_ITEM_TYPES.Episode]: '/show/:item-id:',
  [CONTAINER_ITEM_TYPES.Category]: '/category/:item-id:',
  [CONTAINER_ITEM_TYPES.Character]: '/collection/:item-id:',
  [CONTAINER_ITEM_TYPES.ContinueWatching]: '/player',
  [CONTAINER_ITEM_TYPES.Program]: '/program/:item-id:'
}; // TODO: Devs please align with your routesMapping

const DETAIL_TYPES = {
  [CONTAINER_ITEM_TYPES.Movie]: 'movie',
  [CONTAINER_ITEM_TYPES.Episode]: 'episode',
  [CONTAINER_ITEM_TYPES.Show]: 'show',
  [CONTAINER_ITEM_TYPES.Program]: 'program'
};

const ITEM_TYPES = {
  Wide: 'wide',
  Portrait: 'portrait',
  FeaturedCarouselPortrait: 'featured-carousel-portrait',
  GridPortrait: 'grid-portrait',
  GridLandscape: 'grid-landscape',
  Landscape: 'landscape',
  Square: 'square',
  Bookmark: 'bookmark',
  SeasonEpisode: 'season-episode',
  Categories: 'categories',
  SearchMovie: 'search-movie',
  SearchEpisode: 'search-episode',
  Trend: 'trend',
  HeroBanner: 'hero',
  Character: 'character',
  avatar: 'avatar',
  profilePreview: 'profilePreview',
  ctaButton: 'ctaButton',
  WideBig: 'wide-big',
  WideBigMlb: 'wide-big-mlb'
};

const ANALYTICS_SCREEN_TYPES = {
  page: 'page',
  collection: 'collection',
  myContent: 'myContent',
  profile: 'profile',
  search: 'search',
  login: 'login',
  epg: 'epg',
  settings: 'settings',
  player: 'player',
  category: 'category',
  pairing: 'pairing',
  viewAll: 'viewAll',
  details: 'details',
  profiles: 'profiles',
  scheduleCalendar: 'scheduleCalendar'
};

const PAGE_TEMPLATES = {
  modular: 'elevate-modular-ui',
  collection: 'elevate-collection',
  myContent: 'elevate-my-content',
  profile: 'elevate-profile',
  search: 'elevate-search',
  signin: 'elevate-sign-in',
  epg: 'elevate-epg',
  info: 'elevate-info',
  player: 'elevate-player',
  calendar: 'elevate-calendar',
  category: 'elevate-category',
  about: 'elevate-about',
  pairing: 'elevate-pairing',
  viewAll: 'elevate-view-all',
  showDetail: 'elevate-show-detail',
  movieDetail: 'elevate-movie-detail',
  programDetail: 'elevate-program-detail',
  profiles: 'elevate-profiles',
  nbaSchedule: 'elevate-nba-schedule',
  mlbSchedule: 'elevate-mlb-schedule',
  mlbGameDetails: 'elevate-mlb-game-details',
  sportSchedule: 'elevate-sports-schedule'
};

const IMAGE_TYPE = {
  THUMBNAIL: 'thumbnail',
  COVER: 'cover',
  POSTER: 'poster',
  BACKDROP: 'backdrop',
  BANNER: 'banner'
};

const DEFAULT_LOCALE = 'en';

const API_KEYS = {
  NBA: '84040862c7a74f7291d1a1c1c8d3f9c5',
  MLB: 't99rd66dhd665d688nf5fm8g',
  MLB_LOGO: 'u5rxdtkhyvsqef4dwrc4k4cr'
};

const BASE_URL = {
  nbaScores: 'https://api.sportsdata.io/v3/nba/scores/json',
  nbaStats: 'https://api.sportsdata.io/v3/nba/stats/json',
  mlbApi: 'https://api.sportradar.us/mlb/trial/v7/en'
};

// Nba constants
const NBA_ENDPOINTS = {
  gamesInProgress: '/AreAnyGamesInProgress',
  gamesByDate: '/GamesByDate',
  boxScore: '/BoxScore',
  schedules: '/Games',
  allTeams: '/AllTeams',
  playerByTeam: '/Players',
  referees: '/Referees',
  activeTeams: '/teams',
  currentSeason: '/CurrentSeason',
  demoSportsStream: 'http://13.53.194.134:1337/video-playlists/3'
};
const SEASON_TYPE = {
  PRE: 'PRE',
  POST: 'POST',
  STAR: 'STAR'
};

const GAME_STATUS = {
  SCHEDULED: 'Scheduled',
  LIVE: 'InProgress',
  FINAL: 'Final',
  F_OT: 'F/OT',
  SUSPENDED: 'Suspended',
  POSTPONED: 'Postponed',
  DELAYED: 'Delayed',
  CANCELED: 'Canceled',
  FORFEIT: 'Forfeit',
  NOT_NECESSARY: 'NotNecessary'
};

const TYPE = {
  GAME: 'game',
  TEAM: 'team',
  PLAYER: 'player',
  CATCHUP: 'catchup',
  LIVE: 'live',
  MERCHANDISE: 'merchandise'
};

const DEFAULT_COLOR = {
  primary: '#535353',
  secondary: '#3A3A3A',
  tertiary: '#A6A6A6',
  quaternary: '#ABABAB'
};

const DUMMY_VIDEO_URL =
  '//d3qnhznroa8hr5.cloudfront.net/videos/bbb_multiaudio.mp4';
const MLB_STREAM_URL =
  'https://accedo-global-solutions-public.s3.amazonaws.com/videos/Blue+Jays+vs.+Red+Sox+Game+Highlights+(5_2_23)+_+MLB+Highlights.mp4';
const APP_QS_KEY = 'elevate_qs';
const APPID_STORE_KEY = 'elevate_appId';
const GID_STORE_KEY = 'elevate_gid';
const QS_GID_KEY = 'gid';
const QS_APPID_KEY = 'aid';

export {
  ACCEDO_CONTROL_CONTAINER_TEMPLATES,
  ACCEDO_CONTROL_CONTAINER_ID_TEMPLATE_MAP,
  ANALYTICS_SCREEN_TYPES,
  CONTAINER_ITEM_TYPES,
  CONTAINER_ID_TEMPLATE_MAP,
  DEFAULT_TEMPLATE,
  DETAIL_ROUTES,
  DETAIL_TYPES,
  ITEM_TYPES,
  PROVIDER_TYPE,
  SHELF_CONTAINER_IDS,
  ROUTES,
  PAGE_TEMPLATES,
  IMAGE_TYPE,
  DEFAULT_LOCALE,
  APP_QS_KEY,
  APPID_STORE_KEY,
  GID_STORE_KEY,
  QS_APPID_KEY,
  QS_GID_KEY,
  SEASON_TYPE,
  API_KEYS,
  BASE_URL,
  NBA_ENDPOINTS,
  GAME_STATUS,
  TYPE,
  DEFAULT_COLOR,
  DUMMY_VIDEO_URL,
  MLB_STREAM_URL
};
